import React, { useState } from "react";
import { Card, CardBody, Col, Form, FormGroup, Input } from "reactstrap";
import ToastPlacementContent from "./ToastPlacementContent";
import { ToastPlacementTitle } from "../../../../constants";
import { ToastPlacementOptions, ToastPlacementSubTitle } from "../../../../data/bonusUi/Toasts";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const ToastPlacement = () => {
  const [selectedPosition, setSelectedPosition] = useState("");
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={ToastPlacementTitle} span={ToastPlacementSubTitle} />
        <CardBody className="toast-rtl toast-dark">
          <Form>
            <FormGroup>
              <Input className="mt-2" name="toastPlacement" type="select" value={selectedPosition} onChange={(event) => setSelectedPosition(event.target.value)}>
                {ToastPlacementOptions.map((options, index) => (
                  <option value={options.value} key={index}>
                    {options.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Form>
          <ToastPlacementContent selectedPosition={selectedPosition} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ToastPlacement;
